module.exports = __webpack_public_path__ + "media/images/es-dec6ea19.svg";